import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
//import { ref } from 'vue';
//import { signupFormInfo } from '@/models/signupModel';
import LoginRepository from '@/repositories/loginRepository';
//import SetupCompanyRepository from '@/repositories/setupCompanyRepository';
import SignupRepository from '@/repositories/signupRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
//import cognitoRepository from '@/repositories/common/cognitoRepository';

export const useSignupStore = defineStore({
    id: 'signup',
    state: () => ({
        SignupPk: '',
        UserId: '',
        ClientType: '',
        LoginId: '',
        CmpFmlPwd: '',
    }),
    actions: {
        reset() {
            this.SignupPk = '';
            this.UserId = '';
            this.ClientType = '';
            this.LoginId = '';
            this.CmpFmlPwd = '';
        },
        /**
         * サインアップ1画面目の事前チェック処理
         */
        async checkUserSignUpCredentialAction(API_URL, requestBody) {
            const signupRepository = new SignupRepository();
            try {
                // 自己サインアップ事前チェックAPIをコールする。
                const response = await signupRepository.sendSignUpCheckActionApi(API_URL, requestBody, null);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * サインアップ入力処理
         * @param {signupFormInfo} request
         */
        async checkUserSignUpAction(API_URL, requestBody) {
            const signupRepository = new SignupRepository();
            try {
                // 自己サインアップ1APIをコールする。
                const response = await signupRepository.sendSignUp1ActionApi(API_URL, requestBody, null);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                // 自己サインアップ1APIの判定処理では、200 OKのレスポンス結果のエラーフラグを一律エラーにせず、画面に返却する。
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * サインアップ確認処理
         * @param {signupFormInfo} request
         */
        async CompleteSignUpAction(API_URL, requestBody) {
            const signupRepository = new SignupRepository();
            try {
                // 自己サインアップ2APIをコールする。
                const response = await signupRepository.sendSignUp2ActionApi(API_URL, requestBody, null);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'post', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },

        /**
         * 個人情報取扱規定取得APIをコールする。
         * @param {Object} queryParam
         * @returns response
         */
        async getRegPvcInfoAction(API_URL, queryParam) {
            const loginRepository = new LoginRepository();
            try {
                const response = await loginRepository.getRegPvcContentApi(API_URL, queryParam);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                return { success: true, responseBody: response.data };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
    },
    persist: {
        // セッションストレージに保存する。
        storage: sessionStorage,
    },
});
